import type { FC } from "preact/compat";
import type { TextFieldProps } from "./interfaces";
import cn from "classnames";

const TextField: FC<TextFieldProps> = ({
    className,
    leftIcon,
    rightIcon,
    disabled,
    label,
    inputClassName,
    placeholder,
    disabledPlaceholder,
    inputRef,
    ...rest
}) => (
    <div className={cn("flex flex-col", className && String(className))}>
        {typeof label === "string" ? (
            <span className="text-sm text-gray-500">{label}</span>
        ) : (
            label
        )}
        <div
            className={cn(
                "relative flex items-center rounded-3xl border border-gray-300 transition duration-100",
                "focus-within:ring-2 focus-within:ring-sky-500 focus-within:ring-offset-2 focus-within:ring-offset-white",
                disabled && "bg-gray-100",
            )}
        >
            <input
                ref={inputRef}
                className={cn(
                    "peer h-full w-full rounded-3xl border-none px-4 py-[5px] outline-none transition duration-100 focus:caret-sky-500",
                    "disabled:placeholder:text-gray-400",
                    leftIcon && "pl-7",
                    rightIcon && "pr-7",
                    inputClassName,
                )}
                disabled={disabled}
                placeholder={
                    !rest.value && disabledPlaceholder
                        ? disabledPlaceholder
                        : placeholder
                }
                {...rest}
            />
            {leftIcon && (
                <span className="absolute left-2 h-4 w-4 fill-current text-gray-500 transition duration-100 peer-focus:text-sky-500 peer-disabled:text-gray-300">
                    {leftIcon}
                </span>
            )}
            {rightIcon && (
                <span className="absolute right-2 flex h-4 w-4 items-center fill-current text-gray-500 transition duration-100 peer-focus:text-sky-500 peer-disabled:text-gray-300">
                    {rightIcon}
                </span>
            )}
        </div>
    </div>
);

export default TextField;
